// extracted by mini-css-extract-plugin
export default {"portal-container":"VJm87ktS31Z5wVi3Tu1h"};